import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import ShakaPlayerComponent from "../../components/video/ShakaPlayerComponent";
import { fetchSignedCookie } from "../../utils/videoUtils";

type VideoData = {
  id: string;
  title: string;
  key: string;
  [key: string]: any;
};

const VideoDetail: React.FC = () => {
  const { videoId } = useParams<{ videoId: string }>();
  const [video, setVideo] = useState<VideoData | null>(null);
  const [playbackUrl, setPlaybackUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchVideo = async () => {
      try {
        const snap = await getDoc(doc(db, "videos", videoId!));
        if (!snap.exists()) {
          setError("動画が見つかりません。");
          return;
        }
        const data = snap.data() as VideoData;
        const videoData: VideoData = { ...data, id: snap.id };
        setVideo(videoData);

        // m3u8パス生成
        const parts = videoData.key.split("/");
        const videoIdPart = parts[1];
        const fileBaseName = parts[2]?.replace(/\.[^/.]+$/, "");
        const m3u8Path = `converted/${videoIdPart}/${fileBaseName}/playlist.m3u8`;

        // Cookie取得・document.cookieへセット
        try {
          const { cookies } = await fetchSignedCookie(m3u8Path);
          if (!cookies) throw new Error("Cookieが空です");
          Object.entries(cookies).forEach(([name, value]) => {
            document.cookie = `${name}=${value}; Path=/; Secure; SameSite=None; Domain=.toa-fans.shop`;
          });
        } catch (cookieErr: any) {
          setError("Cookieの取得に失敗しました: " + (cookieErr.message || String(cookieErr)));
          return;
        }

        // CloudFront直URLをセット
        const cloudfrontDomain = "d3ak0hnhe68mgk.cloudfront.net";
        const url = `https://${cloudfrontDomain}/${m3u8Path}`;
        setPlaybackUrl(url);

      } catch (err: any) {
        setError("データ取得エラー: " + (err.message || String(err)));
      } finally {
        setLoading(false);
      }
    };
    if (videoId) fetchVideo();
  }, [videoId]);

  if (loading) return <p className="p-6">読み込み中...</p>;
  if (error) return <p className="p-6 text-red-500">{error}</p>;
  if (!video) return <p className="p-6">動画データがありません。</p>;

  return (
    <div className="p-6 max-w-3xl mx-auto space-y-4">
      <h1 className="text-2xl font-bold">{video.title}</h1>
      {playbackUrl ? (
        <ShakaPlayerComponent playbackUrl={playbackUrl} />
      ) : (
        <p className="text-gray-400">再生URLがありません。</p>
      )}
    </div>
  );
};

export default VideoDetail;
